import React, {Component} from 'react';
import {Breadcrumb, Grid, Header, Icon, Statistic} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import DataService from "../../functions/DataService";
import C from "../../constants";


class RepairShopHome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            stats: [],
            loading: true
        }
        this.get_total_stat = this.get_total_stat.bind(this)
    }

    componentDidMount() {
        this.initialFetch()
    }

    initialFetch() {
        DataService.get(`technicals-today`, {}).then(stats=>{
            this.setState({stats, loading:false})
        })
    };

    get_total_stat(key){
        let stat = this.state.stats.find(obj => {return obj.delivery_state === key})
        if(stat) return stat.total
        return 0
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Quipuu - Inicio</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Inicio</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Grid columns={1}>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Header as='h2' icon textAlign='center'>
                                <Icon name='medkit'/>
                                <Header.Content>
                                    Reparaciones y/o Mantenimientos
                                </Header.Content>
                            </Header>
                            <Statistic.Group size='small' widths={4} style={{verticalAlign: 'initial', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                {C.REPAIR_SHOP_STATUS.map((status) =>{
                                    return <Statistic style={{padding:'1em'}} key={status.key}>
                                        <Statistic.Value>
                                            <Icon name={status.icon} /> {this.state.loading ? <Icon loading name='spinner' />:this.get_total_stat(status.key)}
                                        </Statistic.Value>
                                        <Statistic.Label>{status.text}</Statistic.Label>
                                    </Statistic>
                                })}
                            </Statistic.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default RepairShopHome;



// WEBPACK FOOTER //
// ./src/containers/home/RepairShopHome.js